"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "guarcino": {
    "a5678979": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "colle": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "634e352e": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "cona-medagliata": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0078ce79": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-castagnola": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f42eaae": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "coriano-lisciano": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be708b9a": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "menticchio": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "37cf81e2": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a992aa8a": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "88312eb2": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "tori-ita": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3ee3e68d": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "vesperano": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38a1c337": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "skipSearch": false
    }],
    "vigne-strutte": [{
      "hkey": "45c29096",
      "slug": "guarcino",
      "name": "Guarcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;